import { PetType } from 'petData';

const Pet = {
  0: PetType.Yeti,
  1: PetType.Dodo,
  2: PetType.Alista
};

export default Pet;
